module.exports = __webpack_public_path__ + "img/idle-dj-details8.0c770351.png";